import React from 'react';

import { flagStyles } from '../settings';

const SvgET = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-1608px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgET;
